import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight, FiShield, FiZap, FiTarget } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#0A0A0A]">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-asphalt-dark/40 to-asphalt-dark z-10"></div>
        <img 
          src="https://images.unsplash.com/photo-1541625602330-2277a4c4b082?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" 
          alt="Urban Street" 
          className="w-full h-full object-cover opacity-50 grayscale hover:grayscale-0 transition-all duration-1000"
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-20 w-full pt-20">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-8">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="flex items-center gap-4 mb-8">
                <div className="h-[2px] w-12 bg-signal"></div>
                <span className="text-signal font-black text-xs tracking-[0.4em] uppercase">Tactical Urban Gear</span>
              </div>
              
              <h1 className="text-6xl md:text-[120px] font-black uppercase leading-[0.85] tracking-tighter mb-10">
                Outpace <br/>
                <span className="text-stroke">The Grid.</span>
              </h1>
              
              <p className="text-lg md:text-xl text-gray-400 font-medium mb-12 max-w-xl leading-relaxed">
                Industrial-grade security and visibility systems engineered for the chaos of the modern commute. No compromises, just performance.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-6">
                <a href="#shop" className="group bg-signal hover:bg-white text-white hover:text-signal font-black text-sm py-5 px-10 flex items-center justify-center gap-4 transition-all uppercase tracking-[0.2em] rounded-sm">
                  Explore Arsenal
                  <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-2 transition-transform" />
                </a>
                <a href="#builder" className="group bg-white/5 hover:bg-white/10 text-white border border-white/10 font-black text-sm py-5 px-10 flex items-center justify-center transition-all uppercase tracking-[0.2em] rounded-sm backdrop-blur-sm">
                  Build Custom Kit
                </a>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-4 hidden lg:block">
            <motion.div 
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.5, duration: 1 }}
              className="relative"
            >
              <div className="absolute -inset-10 border border-signal/20 rounded-full animate-pulse"></div>
              <div className="relative z-10 space-y-8 bg-asphalt-light/50 p-10 border border-white/10 backdrop-blur-xl">
                {[
                  { icon: FiShield, title: 'Grade 10 Security', desc: 'Indestructible U-Locks' },
                  { icon: FiZap, title: '1200 Lumens', desc: 'Daylight Visibility' },
                  { icon: FiTarget, title: 'Precision Fit', desc: 'Zero-Rattle Mounting' }
                ].map((item, i) => (
                  <div key={i} className="flex gap-4">
                    <div className="w-12 h-12 bg-signal/10 flex items-center justify-center text-signal border border-signal/20">
                      <SafeIcon icon={item.icon} className="text-2xl" />
                    </div>
                    <div>
                      <h4 className="font-black uppercase text-sm tracking-widest">{item.title}</h4>
                      <p className="text-gray-500 text-xs mt-1">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-30">
        <span className="text-[10px] font-black uppercase tracking-[0.3em]">Scroll</span>
        <div className="w-[1px] h-12 bg-white"></div>
      </div>
    </section>
  );
};

export default Hero;